export default {
  id: "beyond-books-childhood-trailer",
  pride: 45056,
  slug: "beyond-books-childhood-trailer",
  series: "beyond-books",
  category: ["video", "novel"],
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "【OC动画】不止于纸上的故事：童年篇 预告",
    en: "[OC Animation] Beyond Books: Childhood Arc — Trailer"
  },
  bilibiliVideoId: "BV1psoBY8E9L",
  descriptionKey: {
    zh: "银月篇四年后，一位画家独自前往传说中的异能者保留地，醒来发现整个镇子的人全部消失了。AI导演工作流产出，迄今最满意的动画作品。",
    en: "Four years after the Silver Moon arc. A painter ventures to the legendary esper reservation alone — and wakes to find the entire town has vanished. Made with an AI director workflow. The most satisfying animation work to date."
  },
  date: { year: 2025, month: 3, day: 23 },
  genres: ["OC动画", "预告片", "AI动画"],
  themes: ["逆模因", "异能者", "消失", "记忆", "虚无间"],
  developerNotesKey: {
    zh: "故事发生在银月篇四年之后，画家探访异能者保留地，醒来发现全镇人消失。故事受逆模因部、JoJo、罗伯特·麦基、尼尔·盖曼启发。虚无间（VOID）灵感来源于SCP-3125，穿和服的小女孩，通过认知定位生物并吞噬其记忆消灭之；面对她的武器是多米尼克，一位拥有删除记忆能力的机器人。1:22处镜头为全片精华。制作流程：写剧本→AI生图选角→ViduAI试镜→筛2000镜头留300→SunoAI生成100首曲→DubbingX配音→逐帧打字幕，产出2分钟预告。所有动画作品中最满意的一部。",
    en: "Set four years after Silver Moon. A painter visits the legendary esper reservation and wakes to find the entire town gone. Inspired by SCP Anti-Memetics Division, JoJo, Robert McKee, and Neil Gaiman. VOID — inspired by SCP-3125 — is a kimono-clad girl who locates beings through cognition and devours their memories. Dominique, a robot built to destroy such concept-entities, wields memory deletion as her weapon but remembers almost nothing herself. The shot at 1:22 is the highlight of the whole film. Workflow: script → AI image casting → ViduAI shot trials → screened 2k shots down to 300 → SunoAI generated 100 tracks → DubbingX voice casting → frame-by-frame subtitles → 2-minute trailer. Most satisfying animation work to date."
  },
  tags: ["AI动画", "不止于纸上"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1psoBY8E9L/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
